/**
 * Simple composable for retrieving the current cart state.
 */
export function useCart<T = CartDto>(select?: (data: CartDto) => T) {
  const { loggedIn } = useUserSession()
  const issuer = useIssuer()

  const api = useCartApi()

  return useQuery({
    queryKey: CART_QUERY_KEY,
    // Cart data lives in Core, which rejects Auth0 sessions.
    enabled: computed(() => loggedIn.value && issuer.value !== 'auth0'),
    queryFn: ({ signal }) => api.getOrCreateCart('CRYSTALLIZE_JURIDIKA', signal),
    select,
  })
}
